import { createActions } from "../../utils/reduxsauce";

const { Types, Creators } = createActions(
  {
    getAllPromoters: { args: ["payload"], meta: { async: true } },
    getAllCities: { args: ["payload"], meta: { async: true } },
    getAllSupervisors: { args: ["payload"], meta: { async: true } },
    getPromoter: { args: ["payload"], meta: { async: true } },
    getPermissions: { args: [], meta: { async: true } },
    addPromoter: { args: ["payload"], meta: { async: true } },
    deletePromoter: { args: ["payload"], meta: { async: true } },
    editPromoter: { args: ["payload"], meta: { async: true } },
    showDialog: { args: [], meta: { async: false } },
    showDeleteDialog: { args: [], meta: { async: false } },
    resetDialog: { args: [], meta: { async: false } },
    getAllPromotersAssignments: { args: ["payload"], meta: { async: true } },
    updateContractNumbers: { args: ["payload"], meta: { async: true } },
  },
  {
    prefix: "@app/promoters/",
  },
);
export const ActionTypes = Types;
export default Creators;